<template>
  <div class="enterprise-list-page enterprise-list-page--report">
    <!-- Header Card -->
        <PageHeader icon="fas fa-user-tie">
      <template #title>
        Laporan Komisi Pegawai
      </template>
      <template #subtitle>
        Pantau komisi dan kontribusi pegawai secara terstruktur
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import ReportPageShell from '@/component/reports/ReportPageShell.vue'
import VueHtml2pdf from "vue-html2pdf"
import Table from '@/component/reports/EmployeeCommisionReportTable.vue'
import Card from '@/view/content/Card.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    ReportPageShell,
    Table,
    VueHtml2pdf
  },

  data() {
    return {
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    }
  },

  methods: {



  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Laporan", route: "" },
      { title: "Laporan Komisi Pegawai" },
    ])    
  },

}
</script>

<style>
</style>
